import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Tabs,
  Descriptions,
  Spin,
  Modal,
  Typography,
  message,
} from "antd";
import { useParams } from "react-router-dom";
import { FileImageOutlined } from "@ant-design/icons";
import axios from "axios";

const { TabPane } = Tabs;
const { Title } = Typography;

const InspectionDetails = () => {
  const { id } = useParams();
  const [inspectionData, setInspectionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  useEffect(() => {
    fetchInspectionData();
  }, [id]);

  const fetchInspectionData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`http://93.127.203.113:5005/inspections/${id}`);
      setInspectionData(response.data);
    } catch (error) {
      message.error("Unable to load inspection details");
    } finally {
      setLoading(false);
    }
  };

  const handlePreview = (src) => {
    setPreviewImage(src);
    setPreviewVisible(true);
  };

  const renderImage = (src, label) => (
    <Card
      hoverable
      style={{
        textAlign: "center",
        borderRadius: "10px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      }}
      cover={
        src ? (
          <img
            alt={label}
            src={`http://93.127.203.113:5005${src}`}
            onClick={() => handlePreview(`http://93.127.203.113:5005${src}`)}
            style={{
              height: "200px",
              objectFit: "cover",
              cursor: "pointer",
              borderRadius: "10px 10px 0 0",
            }}
          />
        ) : (
          <div
            style={{
              height: "200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#f0f2f5",
              borderRadius: "10px 10px 0 0",
            }}
          >
            <FileImageOutlined style={{ fontSize: "48px", color: "#ccc" }} />
            <p style={{ marginTop: "10px", color: "#aaa" }}>{label}</p>
          </div>
        )
      }
    >
      <Card.Meta title={label} />
    </Card>
  );

  return (
    <div style={{ padding: "20px" }}>
      {loading ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Card
          style={{
            borderRadius: "10px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            borderTop: "5px solid #0c8c49",
          }}
        >
          <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
            Inspection Details
          </Title>
          <Tabs defaultActiveKey="1" type="card">
            <TabPane tab="Inspection Overview" key="1">
              <Row gutter={[24, 24]}>
                <Col span={24} md={12}>
                  <Card
                    title="Inspection Information"
                    bordered={false}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Descriptions bordered column={1}>
                      <Descriptions.Item label="Vehicle">
                        {inspectionData?.vehicle?.plateNumber} (
                        {inspectionData?.vehicle?.model})
                      </Descriptions.Item>
                      <Descriptions.Item label="Fuel Status">
                        {inspectionData?.fuelStatus}
                      </Descriptions.Item>
                      <Descriptions.Item label="Status">
                        {inspectionData?.status}
                      </Descriptions.Item>
                      <Descriptions.Item label="Remarks">
                        {inspectionData?.remarks || "N/A"}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </Col>
                <Col span={24} md={12}>
                  <Card
                    title="Vehicle Details"
                    bordered={false}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Descriptions bordered column={1}>
                      <Descriptions.Item label="Model">
                        {inspectionData?.vehicle?.model}
                      </Descriptions.Item>
                      <Descriptions.Item label="Color">
                        {inspectionData?.vehicle?.color}
                      </Descriptions.Item>
                      <Descriptions.Item label="Manufactured Year">
                        {inspectionData?.vehicle?.manufacturedYear || "N/A"}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Inspection Photos" key="2">
              <Row gutter={[16, 16]}>
                {[
                  { label: "Top View", src: inspectionData?.topPhoto },
                  { label: "Front View", src: inspectionData?.frontPhoto },
                  { label: "Back View", src: inspectionData?.backPhoto },
                  { label: "Left View", src: inspectionData?.leftPhoto },
                  { label: "Right View", src: inspectionData?.rightPhoto },
                ].map((photo, index) => (
                  <Col span={12} key={index}>
                    {renderImage(photo.src, photo.label)}
                  </Col>
                ))}
              </Row>
            </TabPane>
          </Tabs>
        </Card>
      )}

      <Modal
        visible={previewVisible}
        title="Image Preview"
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="Preview" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </div>
  );
};

export default InspectionDetails;
